var bottomSheetKeydownHandler = null;
var bottomSheetTriggerHandler = null;
var bottomSheetCloseHandler = null;
var bottomSheetBackdropHandler = null;
var bottomSheetLinkHandlers = [];

document.addEventListener("turbo:load", initMobileWebAiBottomSheet);
document.addEventListener("turbo:load", syncFullscreenBodyClass);

function syncFullscreenBodyClass() {
  if (!document.body.classList.contains("mobile-web-ai")) return;

  var hasFullscreenContent = !!document.querySelector(".mwai-fullscreen-content");
  document.body.classList.toggle("mwai-fullscreen-page", hasFullscreenContent);
}

function initMobileWebAiBottomSheet() {
  if (!document.body.classList.contains("mobile-web-ai")) return;

  var trigger = document.getElementById("mwai-more-trigger");
  var sheet = document.getElementById("mwai-bottom-sheet");
  var backdrop = document.getElementById("mwai-bottom-sheet-backdrop");
  var closeBtn = document.getElementById("mwai-bottom-sheet-close");

  if (!trigger || !sheet || !backdrop) return;

  function openSheet() {
    sheet.classList.add("active");
    backdrop.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeSheet() {
    sheet.classList.remove("active");
    backdrop.classList.remove("active");
    document.body.style.overflow = "";
  }

  if (bottomSheetTriggerHandler) {
    trigger.removeEventListener("click", bottomSheetTriggerHandler);
  }
  bottomSheetTriggerHandler = function (e) {
    e.preventDefault();
    openSheet();
  };
  trigger.addEventListener("click", bottomSheetTriggerHandler);

  if (closeBtn) {
    if (bottomSheetCloseHandler) {
      closeBtn.removeEventListener("click", bottomSheetCloseHandler);
    }
    bottomSheetCloseHandler = function () {
      closeSheet();
    };
    closeBtn.addEventListener("click", bottomSheetCloseHandler);
  }

  if (bottomSheetBackdropHandler) {
    backdrop.removeEventListener("click", bottomSheetBackdropHandler);
  }
  bottomSheetBackdropHandler = function () {
    closeSheet();
  };
  backdrop.addEventListener("click", bottomSheetBackdropHandler);

  bottomSheetLinkHandlers.forEach(function (entry) {
    entry.element.removeEventListener("click", entry.handler);
  });
  bottomSheetLinkHandlers = [];

  var sheetLinks = sheet.querySelectorAll("a[href]:not([href='#'])");
  sheetLinks.forEach(function (link) {
    var handler = function () {
      closeSheet();
    };
    link.addEventListener("click", handler);
    bottomSheetLinkHandlers.push({ element: link, handler: handler });
  });

  if (bottomSheetKeydownHandler) {
    document.removeEventListener("keydown", bottomSheetKeydownHandler);
  }
  bottomSheetKeydownHandler = function (e) {
    if (e.key === "Escape" && sheet.classList.contains("active")) {
      closeSheet();
    }
  };
  document.addEventListener("keydown", bottomSheetKeydownHandler);
}

document.addEventListener("turbo:before-cache", function () {
  var sheet = document.getElementById("mwai-bottom-sheet");
  var backdrop = document.getElementById("mwai-bottom-sheet-backdrop");
  if (sheet) sheet.classList.remove("active");
  if (backdrop) backdrop.classList.remove("active");
  document.body.style.overflow = "";
  document.body.classList.remove("mwai-fullscreen-page");
});
